(function () {

  angular
    .module('meanApp')
    .controller('tagCtrl', tagCtrl);

  tagCtrl.$inject = [
        '$scope', 
        '$uibModal', 
        'loginModal',
        'tagService',
        '$state',
        'searchData'
    ];
  function tagCtrl(
      $scope, 
      $uibModal, 
      loginModal, 
      tagService, 
      $state, 
      searchData) {
    var vm = this,

    iconName = {
    	fast : 'thunder.png',
    	complicated : 'chef.png',
    	protein : 'muscle.png',
    	cold : 'fresh.png',
    	eco : 'bank.png',
    	lowcarb : 'diet.png',
    	nopig : 'no-pig.png',
    	vegan : 'vegan.png',
    	paleo : 'stone-age.png',
    	vegetarian : 'vegan.png',
    	nogluten : 'gluten-free.png',
    	nooven : 'barbecue.png',
    	maincourse : 'maincourse.png',
    	nomicrowave : 'barbecue.png',
    	entry : 'starters.png',
    	pleasure : 'fast-food.png',
    	savory : 'cheese.png',
    	aperitif : 'cocktail.png',
    	lowcalory : 'diet.png',
    	dessert : 'cake.png',
    	sweet : 'donut.png',
    	hot : 'fried.png',
        local : 'earth.png',
        season : 'earth.png',
        nohob : 'barbecue.png'
    };

    vm.onTagSearchClicked = function(nameSent, event) {
        //if tag is not on search mode then do not go to search and block event
        console.log('event is', event);
        if (event.target.parentElement.getAttribute('buttonSearch') === 'true') {
            //go to the search result of the tags directly
            //searchData.setTagsSelected([nameSent]);
            $state.go('recipeSearchResult', {
                tags: nameSent
            });
        }
        else if(event.target.parentElement.getAttribute('buttonLike') !== 'true'){
            //display the modal directly
            this.modalInstance = $uibModal.open({
                templateUrl: 'common/directives/tag/modal.tag.template.html',//relative path to app_client
                controller: 'tagCtrl',
                scope: $scope,
                windowClass: 'tag-description-modal'
            });
        }
    };

    vm.onTagPressed = function(nameSent) {
        //now display the proper modal layout to explain the tag
        //destroy the reference of the previous modal ?
        setTimeout(function() {
            this.modalInstance = $uibModal.open({
                templateUrl: 'common/directives/tag/modal.tag.template.html',//relative path to app_client
                controller: 'tagCtrl',
                scope: $scope,
                windowClass: 'tag-description-modal'
            });
        }.bind(this), 252);//just set a timeout just right above the limit of press recognition
    };

    $scope.goToSearchStepOne = function() {
        $state.go('recipeSearchStep', {
            step: '1'
        });
    };

    //vm.fast =  {nameHTML : 'Rapide'};
    $scope.name = tagService.wording[$scope.tag] || $scope.tag;
    $scope.description = tagService.descriptions[$scope.tag] || '';
    $scope.iconName = iconName[$scope.tag] || '';

  }

})();